module.exports = __webpack_public_path__ + "static/media/world-cup.3d50198c.jpg";